var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomHouseAfford = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.106 12.275V7.41H20.87v1.943L14.982 4 3 14.824h2.768V26h18.446V14.824H27l-2.894-2.549zm-6.832 8.479a3.16 3.16 0 0 1-1.444.708l.01 1.259-1.752.004-.009-1.259c-.526-.12-.906-.369-1.36-.742-.602-.517-.916-1.121-.936-1.798v-.012l.042-.543 1.688-.006.012.332c.007.448.138.774.4 1 .263.235.49.353 1.008.353.51-.004.906-.127 1.176-.365.258-.227.384-.545.384-.97 0-.34-.115-.587-.361-.781-.281-.22-.788-.416-1.504-.583-.869-.202-1.535-.515-1.98-.93a2.245 2.245 0 0 1-.721-1.68c-.005-.762.293-1.397.887-1.886a3.01 3.01 0 0 1 1.217-.604l-.009-1.101 1.752-.012.004 1.064c.514.1.85.306 1.232.616.571.476.881 1.127.925 1.937l.012.355-1.695.01-.047-.287c-.057-.425-.192-.73-.403-.915-.223-.195-.38-.276-.767-.276h-.025c-.446 0-.802.103-1.033.3-.224.186-.326.433-.323.779 0 .29.098.51.298.674.162.136.51.332 1.261.504.974.228 1.72.568 2.216 1.012.523.47.788 1.067.788 1.772.005.837-.312 1.534-.943 2.07z",
    fill: "#1E2969",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomHouseAfford);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-house-afford.12d05309f25536ce2ad58a7dcb1e002b.svg";